import React, { useCallback, useMemo, useState } from 'react';
import { Tag } from 'shared/types/tag';

import { DeleteTagContext } from './delete-tag-context';
import { DeleteTagDialog } from './delete-tag-dialog';

export type DeleteTagProviderProps = {
  children: React.ReactNode;
};

export const DeleteTagProvider: React.FC<DeleteTagProviderProps> = ({
  children,
}) => {
  const [tag, setTag] = useState<Tag>();

  const openDeleteTag = useCallback((tag: Tag) => {
    setTag(tag);
  }, []);

  const closeDialog = useCallback(() => {
    setTag(undefined);
  }, []);

  const value = useMemo(() => ({ openDeleteTag }), [openDeleteTag]);

  return (
    <DeleteTagContext.Provider value={value}>
      {children}
      {!!tag && <DeleteTagDialog tag={tag} onClose={closeDialog} />}
    </DeleteTagContext.Provider>
  );
};
